import member from './Member/route'
import review from './Review/route'

export default [
  ...member,
  ...review
]